// export const base = 'http://localhost:8087/api';
//export const base = 'http://192.168.1.232:8081/api';


// export const base = "http://192.168.1.202:8081/api";

export const base = "https://rutasegura-api.telemetriaperu.com/api";

export const loginURL = `${base}/empresas/login`
 
// Ruta
export const rutasURL = `${base}/rutas`;
export const rutasxEmpresaURL = `${rutasURL}/xempresa`
export const rutasxEmpresaPURL = `${rutasURL}/xempresaP/`
export const rutasDeshabilitar = `${rutasURL}/estado/`
// Coordenadas
export const coordenadasURL = `${base}/coordenadas`
export const coordenadaxRutaURL = `${coordenadasURL}/ruta/`;
export const coordenadacxrURL = `${coordenadasURL}/cxr/`

// Paises
export const paisesURL = `${base}/paises`;

// Velocidad
export const sonidosVelocidadURL = `${base}/sonidosVelocidad`

// GeoCerca
export const GeocercaURL = `${base}/SonidoGeo`
export const GeocercaPageURL = `${GeocercaURL}/page`;
export const GeocercaxPaisURL = `${base}/SonidoGeo/xpais/`
export const GeocercaxTipoSURL = `${base}/SonidoGeo/xtipoS/`
export const GeocercaxPaisxTipoURL = `${base}/SonidoGeo/xpaisxtipo/`

// TipoS
export const TipoSURL = `${base}/tipoS`

// Dispositivos
export const DispositivosURL = `${base}/dispositivos`
export const VerificarDisp = `${DispositivosURL}/verificar`
export const ReasignarDisp = `${DispositivosURL}/reasignar`

export const DisxEmp = `${DispositivosURL}/empresax`

// Vehiculos
export const VehiculosURL = `${base}/vehiculos`

// Protocolos
export const ProtocolosURL = `${base}/protocolos`;

// Tipos de vehículo
export const TiposVehiculoURL = `${base}/tipos-vehiculo`;

// Pausas activas y somnolencia
export const PausasActivasURL = `${base}/pausas-activas`;
export const PausasActivasAudioURL = `${PausasActivasURL}/audio`;
export const PausasActivasEnviosURL = `${PausasActivasURL}/envios`;
export const PausasActivasSomnolenciaURL = `${PausasActivasURL}/somnolencia`;
export const PausasProgramadasURL = `${PausasActivasURL}/programaciones`;
export const PausasProgramadasDirectasURL = `${PausasActivasURL}/programadas/directas`;


// Cinturones de seguridad
export const CinturonesSeguridadURL = `${base}/cinturones-seguridad`;
export const CinturonesSeguridadCatalogoURL = `${CinturonesSeguridadURL}/catalogo`;
export const CinturonesSeguridadEventosURL = `${CinturonesSeguridadURL}/eventos`;
export const CinturonesSeguridadResumenURL = `${CinturonesSeguridadURL}/resumen`;
export const CinturonesSeguridadDashboardURL = `${CinturonesSeguridadURL}/dashboard`;
export const CinturonesSeguridadExportarURL = `${CinturonesSeguridadURL}/exportar`;
export const CinturonesSeguridadPosicionesURL = `${CinturonesSeguridadURL}/posiciones`;
export const CinturonesSeguridadVehiculoAsignacionURL = (vehiculoId) => `${CinturonesSeguridadURL}/vehiculos/${vehiculoId}/asignacion`;
export const CinturonesSeguridadVehiculoSyncURL = (vehiculoId) => `${CinturonesSeguridadURL}/vehiculos/${vehiculoId}/sincronizar-posiciones`;

//Empresas 
export const EmpresasURL = `${base}/empresas`
export const EmpresaFNombre = `${EmpresasURL}/findNombre`;
export const EmpresaFUsuario = `${EmpresasURL}/findUsuario`;
